import { CANVAS_OBJECT_TYPE_PREFIX } from '~/core/constants';

export const isTargetElement = (element: fabric.Object): boolean =>
  [
    CANVAS_OBJECT_TYPE_PREFIX.CORNER_RADIUS_ARC,
    CANVAS_OBJECT_TYPE_PREFIX.BUMP_OUT,
    CANVAS_OBJECT_TYPE_PREFIX.RADIUS_OUT,
  ].some((prefix) => element.name?.includes(prefix));
